import type { AxiosInstance } from 'axios'
import type { IFactoryFunctionRequest } from '@bc-library/interface'
import { EMethod } from '@bc-library/interface'
import { API_MAIN_VERSION, BASE_URL } from '@/config/constantes'
import useAxios from '@/services/api/useAxios'

const resource = 'jobCategorys'

type TJobCategory = {
  _id: string
  display: string
  isDeleted?: boolean
}

const getFirm = (axios: IFactoryFunctionRequest<Array<TJobCategory>, undefined>) => (firmId: string) => {
  return axios({
    method: EMethod.get,
    url: `${BASE_URL}/${API_MAIN_VERSION}/${resource}/firm/${firmId}`,
  })
}

const v2Filter = (axios: IFactoryFunctionRequest<{ docs: TJobCategory[]; count: { total: number; hasNextPage: boolean } }, undefined>) => ({
  page = 0,
  limit = 100,
  search = '',
}: {
  page?: number
  limit?: number
  search?: string
}) => {
  return axios({
    method: EMethod.get,
    url: `${BASE_URL}/${API_MAIN_VERSION}/${resource}/v2/settings/filter`,
    query: { page, limit, search },
  })
}

const create = (axios: IFactoryFunctionRequest<TJobCategory, Partial<TJobCategory>>) => (data: Partial<TJobCategory>) => {
  return axios({
    method: EMethod.post,
    url: `${BASE_URL}/${API_MAIN_VERSION}/${resource}`,
    data,
  })
}

const createManagement = (axios: IFactoryFunctionRequest<TJobCategory, Partial<TJobCategory>>) => (data: Partial<TJobCategory>) => {
  return axios({
    method: EMethod.post,
    url: `${BASE_URL}/${API_MAIN_VERSION}/${resource}/v2/management/create`,
    data,
  })
}

const update = (axios: IFactoryFunctionRequest<TJobCategory, Partial<TJobCategory>>) => (jobCategoryId: string, data: Partial<TJobCategory>) => {
  return axios({
    method: EMethod.put,
    url: `${BASE_URL}/${API_MAIN_VERSION}/${resource}/${jobCategoryId}`,
    data,
  })
}

export default (axios: AxiosInstance) => ({
  getFirm: getFirm(useAxios(axios)),
  v2Filter: v2Filter(useAxios(axios)),
  create: create(useAxios(axios)),
  createManagement: createManagement(useAxios(axios)),
  update: update(useAxios(axios)),
})
